<template>
    <div>
      <div :style="'z-index: 0;position: relative;height:160px;color#fff;padding:15px;background-image: linear-gradient(0deg,' + $bgColor + '0%,' + $bgColor2 + '100%);'">
        <div :style="'height: 143px;background-color:' + $bgColor2 + ';width: 143px;border-radius: 100px;position: absolute;z-index: -1;right: 14px;top: -52px;'"></div>
        <div :style="'height: 90px;background-color:' + $bgColor2 + ';width: 45px;border-top-left-radius: 110px;border-bottom-left-radius: 110px;position: absolute;z-index: -1;right: 1px;top: 29px;'"></div>
        <div :style="'height: 89px;background-color:' + $bgColor3 + ';width: 89px;border-radius: 100px;position: absolute;z-index: -1;right: 17px;top: 58px;'"></div>
        <v-row>
          <strong style="color:#fff;font-size: 20px;padding:15px;">{{ $t("message.MyPoint") }}</strong>
          <div style="align-items: center;display: flex;">
            <img
                  v-if="profile.pictureUrl && !$isTargetShop()"
                  style="
                    border-color: white;
                    height: 40px;
                  "
                  alt="Avatar"
                  :src="require('@/assets/star.png')"
                  />
                  <img
                v-else
                style="
                  border-color: white;
                  height: 30px;
                "
                alt="Avatar"
                :src="require('@/assets/DimondWhite.svg')"
              />
          </div>
        </v-row>
          <v-row justify="center" class="mt-3 pt-2">
            <v-col cols="4" align="center" class="pa-2" style="font-size:15px;background-color:#ffff;box-shadow: 0px 1px 1px 0px #00000040;border-top-left-radius: 15px;border-bottom-left-radius: 15px;">
              {{ $t("message.MyPoint") }}
            <v-col align="center" class="pa-0" :style="'font-weight: bold;font-size:20px;color:' + $bgColor" >{{ formatNumber(newData.currentPoint) }}</v-col>
          </v-col>
           <v-col cols="4" align="center" class="pa-2" style="font-size:15px;background-color:#ffff;box-shadow: 0px 1px 1px 0px #00000040;border-top-right-radius: 15px;border-bottom-right-radius: 15px;">
              {{ $t("message.PointsUsed") }}
            <v-col align="center" :style="'font-weight: bold;font-size:20px;color:' + $bgColor" class="pa-0">{{ formatNumber(newData.redeemPoint) }}</v-col>
          </v-col>
          </v-row>
      </div>
      <!-- ------------------------------------------------- -->
      <div class="choice" :style="'margin-left:15px;border: 1px solid '+$bgColor+';' " @click="$router.push('/ExchangeToDiscount').catch(()=>{})">
            <!-- cal -->
            <div style="display: flex; justify-content: center; align-items: center;padding: 10px;">
              <img :src="require('@/assets/discount.png')" alt="" width="40" style="margin-right: auto;">
              <h3 style="margin-left: auto; font-size: 1.25rem;">{{ $t("message.ExchangeToDiscount") }}</h3>
            </div>
        </div>
      <!-- ------------------------------------------------- -->
      <div class="choice" :style="'margin-left:15px;border: 1px solid '+$bgColor+';' " @click="$router.push('/Transaction').catch(()=>{})">
            <!-- cal -->
            <div style="display: flex; justify-content: center; align-items: center;padding: 10px;">
              <img :src="require('@/assets/payment.png')" alt="" width="40" style="margin-right: auto;">
              <h3 style="margin-left: auto; font-size: 1.25rem;">{{ $t("message.pointHistory") }}</h3>
            </div>
        </div>
      <!-- ------------------------------------------------- -->
    </div>
  </template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MyPoints',
  data () {
    return {
      dialogConfromLin: false,
      member: null,
      profile: null,
      use: null,
      items: null,
      dialog: false,
      today: new Date(),
      tab: null,
      shopId: null,
      selected: ''
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    window.scrollTo(0, 0)
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    this.shopId = this.GET_SHOPID()
    // await this.getPackage()
    // await this.getPackageTransaction()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID'])
  },
  computed: {
    newData () {
      return this.GET_MEMBERINFO()
    }
  }
}
</script>
<style scoped>
.choice{
  background: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  width: calc(100% - 30px);
  height: 60px;
  border-radius: 15px;
  margin: 10px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/MyPoints.vue